import { defineStore } from "pinia";
import type { Location } from "@Shared";

export const useLocationStore = defineStore("location", {
    state: () => ({
        location: null as Location | null,
        hasLoaded: false,
    }),

    getters: {
        isLoaded: (state) => state.hasLoaded,
    },
    
    actions: {
        setLocation(newLocation: Location) {
            this.location = newLocation;
            this.hasLoaded = true;
        }
    }
});
